
import apiClient from './api';


// Dans votre service api/Order
export const getOrdersByDomainId = async (domainId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/api/order/all/${domainId}${queryString ? `?${queryString}` : ''}`;
  
  const response = await apiClient.get(url);
  return response.data;
};

// afficher les orders par domain
export const getOrdersRfiByDomainId = async (domainId) => {
  try {
    const response = await apiClient.get(`/api/Order/all/OrderRfi/${domainId}`);
    return response.data; // Renvoie les données obtenues de l'API
  } catch (error) {
    // console.error('Erreur lors de la récupération des commandes:', error);
    throw new Error('Failed to fetch RFI orders', error);
    // throw error; // Lance l'erreur pour la gestion dans le composant
  }
};
// Service pour annuler une commande (order)
export const cancelOrder = async (id) => {
  try {
      const response = await apiClient.put(`/api/order/cancel/${id}`);
      return response.data ;
  } catch (error) {
      // console.error("Error cancelling the order", error.response?.data || error.message);
      throw new Error('Failed to cancel the order',error);
  }
};

// // Service pour completer une commande (order)
export const completeOrder = async (orderId) => {
  try {
      const response = await apiClient.put(`/api/Order/complete/${orderId}`);
      return response.data ;
  } catch (error) {
    throw error.response?.data?.message || "Une erreur est survenue.";
  }
};

// Service pour rendre partiell une commande (order)
export const partiallyCompleteOrder = async (orderId) => {
  try {
      const response = await apiClient.put(`/api/Order/partially/${orderId}`);
      return response.data;
  } catch (error) {
      throw error.response?.data?.message || "Une erreur est survenue.";
  }
};

// Service pour marquer une commande comme "Echec Completed"
export const failCompleteOrder = async (orderId) => {
  try {
    const response = await apiClient.put(`/api/Order/fail-complete/${orderId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Une erreur est survenue lors de l'échec de la commande.";
  }
};


// Service pour supprimer une commande (order)
export const deleteOrder = async (orderId) => {
  try {
      const response = await apiClient.delete(`/api/Order/${orderId}`);
      return response.data;
  } catch (error) {
      throw error.response?.data?.message || "Une erreur est survenue.";
  }
};


// * Récupère le nombre d'ordres par marché cible pour un domaine donné
// * @param {number} domainId
// * @returns {Promise<Array>} Liste des marchés cibles et leur nombre d'ordres
// */
export const getOrderCountByTarget = async (domainId) => {
   try {
       const response = await apiClient.get(`/api/Order/countbytarget`, {
           params: { domainId },
       });
       return response.data;
   } catch {
      //  console.error("Erreur lors de la récupération des ordres:", error);
      //  throw new Error("Impossible de récupérer les ordres.",error);
   }
};

/**
 * Récupère le nombre d'ordres d'achat et de vente pour un domaine donné
 * @param {string} domainId
 * @returns {Promise<{nbreAchat:number, nbreVente:number}>}
 */
export const getOrderSideCounts = async (domainId) => {
  try {
    const response = await apiClient.get(`/api/Order/side-counts/${domainId}`);

    return {
      nbreAchat: response?.data?.nbreAchat ?? 0,
      nbreVente: response?.data?.nbreVente ?? 0,
    };
  } catch (error) {
    // console.error("getOrderSideCounts error:", error);

    return { nbreAchat: 0, nbreVente: 0 };
  }
};


// Gestionnaire d'erreurs centralisé
const handleApiError = (error, methodName) => {
  if (error.response) {
    // Erreur serveur
    // console.error(`Erreur API dans ${methodName}:`, {
    //   status: error.response.status,
    //   data: error.response.data,
    // });
    throw new Error(error.response.data?.message || `Erreur ${error.response.status}`);
  } else if (error.request) {
    // Pas de réponse
    // console.error(`Pas de réponse du serveur dans ${methodName}:`, error.request);
    throw new Error('Serveur inaccessible. Vérifiez votre connexion.');
  } else {
    // Erreur de configuration
    // console.error(`Erreur de configuration dans ${methodName}:`, error.message);
    throw new Error('Erreur de configuration de la requête');
  }
};

export const createOrder = async (orderData, config = {}) => {
  try {
    // Si ce n'est pas déjà un FormData, le transformer en FormData
    let payload;
    if (orderData instanceof FormData) {
      payload = orderData;
    } else {
      payload = new FormData();
      Object.entries(orderData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          payload.append(key, value);
        }
      });
    }

    // Toujours multipart/form-data pour FromForm
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
      ...(config.headers || {})
    };

    const response = await apiClient.post('/api/Order', payload, { ...config, headers });

    return response.data;

  } catch (error) {
    if (error.response) {   
      return Promise.reject(error.response.data);
     }
    throw error;
  }
};


export const createSubscriptionOrder = async (orderData, config = {}) => {
  try {
    const isFormData = orderData instanceof FormData;
    const headers = { ...(config.headers || {}) };

    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }
    const response = await apiClient.post(
      '/api/Order/souscrire', 
      orderData,
      { ...config, headers }
    );
    return response.data;
  } catch (error) {
    // ... gestion d'erreur ...
    throw new Error("Failed to create subscription order", error);
  }
};
// Charger les TargetMarkets
export const getTargetMarkets = async () => {
  try {
    const response = await apiClient.get(`/api/TargetMarket/all`);
    // console.log("liste des targets market recuperer", data); 
    return response.data;
  } catch (error) {
    // console.error("Error fetching target markets:", error);
    throw new Error('Failed to fetch target markets', error);
  }
};

// Charger les comptes
export const getAccounts = async (domainId, params = {}) => {
  try {
    const response = await apiClient.get('/api/accounts/all', {
      params: {
        domainId,
        pageNumber: params.pageNumber ?? 1,
        pageSize:   params.pageSize   ?? 99999,   // fetch everything by default
        ...params,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch accounts: ' + (error?.message ?? ''));
  }
};


export const getAccount = async (domainId) => {
  try {
    const response = await apiClient.get('/api/accounts/all', { params: {domainId} });
    return response.data.items;
  } catch (error) {

    throw new Error('Failed to fetch accounts', error);
  }
};

export const getAccountss = async (domainId) => {
  try {
    const response = await apiClient.get('/api/accounts/all', { 
      params: { domainId } 
    });
    
    // Si l'API retourne un objet paginé, extraire les items
    if (response.data && response.data.items) {
      return response.data.items; // Retourne le tableau des comptes
    }
    
    // Sinon, retourner la réponse telle quelle (supposant que c'est un tableau)
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch accounts', error);
  }
};

// Service pour mettre à jour un ordre
// service/api/Order.js - Ajouter cette fonction

// Service pour mettre à jour un ordre
// Service pour mettre à jour un ordre
export const updateOrder = async (orderData, config = {}) => {
  try {
    // Utiliser FormData pour la mise à jour aussi
    const fd = new FormData();

    Object.entries(orderData).forEach(([key, value]) => {
      if (key === "Preuve") {
        if (value && value instanceof File) {
          fd.append("Preuve", value);
        }
      } else if (value !== undefined && value !== null && value !== "") {
        fd.append(key, value);
      }
    });

    const headers = {
      'Content-Type': 'multipart/form-data',
      ...(config.headers || {})
    };

    const response = await apiClient.put(`/api/Order/${orderData.Id}`, fd, { 
      ...config, 
      headers 
    });

    return response.data;

  } catch (error) {
    if (error.response) {
      
      // Gestion des erreurs spécifiques
      const status = error.response.status;
      const message = error.response.data?.message || 'Erreur lors de la mise à jour';
      
      switch (status) {
        case 400:
          throw new Error(message || 'Données invalides');
        case 404:
          throw new Error('Ordre non trouvé');
        case 403:
          throw new Error('Vous n\'êtes pas autorisé à modifier cet ordre');
        case 409:
          throw new Error('L\'ordre ne peut pas être modifié dans son état actuel');
        default:
          throw new Error(`Erreur serveur: ${message}`);
      }
    } else {
      throw new Error('Erreur réseau ou serveur indisponible');
    }
  }
};

//  Fonction pour récupérer le volume des commandes par mois et année
export const getOrdersByMonth = async (domainId) => {
  try {
      const response = await apiClient.get(`api/Order/GetOrdersByMonth`, {
          params: { domainId }
      });

      if (!Array.isArray(response.data)) {
          return [];
      }

      return response.data.map((item) => {
          if (!item.year || !item.month || item.volume === undefined) {
              return { month: "N/A", volume: 0 };
          }

          return {
              month: new Date(item.year, item.month - 1).toLocaleString("fr-FR", { month: "short" }),
              volume: item.volume,
          };
      });

  } catch (error) {
      return [];
  }
};

// liste des ordres d'un account 
export const getOrderByIssuerAccountId = async (fromAccountId, domainId, page = 1, pageSize = 10) => {
  try {
    if (!fromAccountId || !domainId) {
      throw new Error("fromAccountId ou domainId est invalide.");
    }

    const response = await apiClient.get(
      `/api/Order/getOrderByFromAccount/${fromAccountId}/${domainId}?page=${page}&pageSize=${pageSize}`
    );
    return response.data; // array
  } catch (error) {
    const status = error.response?.status;
    const message = error.response?.data?.message || "Une erreur est survenue.";

    if (status === 404) {
      // Si c'est un "not found", on considère qu'il n'y a juste pas d'ordre (optionnel)
      return []; // ou null si tu préfères gérer différemment
    }

    // console.error("Erreur lors de la récupération des Ordres :", message);
    throw message;
  }
};


// Récupérer le volume et le nombre d'ordres pour un client
export const getVolumeOrdersByClient = async (accountId, domainId) => {
   try {
     const response = await apiClient.get(`/api/Order/VolumeOrdersByClient/${accountId}/${domainId}`
     );
     // La réponse attendue contient { Volume, Count }
     return response.data;
   } catch (error) {
     throw new Error('Failed to fetch volume and count of orders for client', error);
   }
};

// evolution des ordres d'un client dans un domain precis
export const getEvolutionOrderClient = async (accountId, domainId) => {
  try {
      const response = await apiClient.get(`/api/Order/GetEvolutionOrderClient/${accountId}/${domainId}`);
      return response.data;
  } catch (error) {
      throw new Error("Erreur lors de la récupération de l'évolution des ordres du client:", error);
  }
};


// evolution des ordres d'un domain dans un domain precis
export const getEvolutionOrderPrivate = async (domainId) => {
  try {
    const response = await apiClient.get(`/api/Order/GetEvolutionOrderPrivate?domainId=${domainId}`);
    return response.data;
  } catch (error) {
    throw new Error('Erreur lors de la récupération des ordres privés:', error);
  }
};

export const getEvolutionOrderMonetary = async (domainId) => {
  try {
    const response = await apiClient.get(`/api/Order/GetEvolutionOrderMonetary?domainId=${domainId}`);
    return response.data;
  } catch (error) {
    throw new Error('Erreur lors de la récupération des ordres monétaires:', error);
  }
};

export const getEvolutionOrderFinancial = async (domainId) => {
  try {
    const response = await apiClient.get(`/api/Order/GetEvolutionOrderFinancial?domainId=${domainId}`);
    return response.data;
  } catch (error) {
    throw new Error("Erreur lors de la récupération des ordres financiers:", error);
  }
};

// get by id d'un ordre
export const getOrderById = async (ordreId) => {
  try {
      const response = await apiClient.get(`/api/Order/order/${ordreId}`);
      return response.data;
  } catch (error) {
      throw new Error("Erreur lors de la récupération de l'ordre par ID:", error);
  }
};

export const getSubscribersBySecurity = async (securityId,domainId) => {
  const { data } = await apiClient.get(
    `/api/Order/subscribers/${securityId}/${domainId}`);
  return data; // Array of Account
};




